import { EmblaViewportRefType } from 'embla-carousel-react';
import { PACKAGE_DATA } from 'src/constants/dummy';
import '../../../styles/embla.css';
import PackageCard from '../Cards/PackageCard';

const PackageCarousel = ({ emblaRef }: { emblaRef: EmblaViewportRefType }) => {
  // rendering package carousel component here
  return (
    <div className='embla flex-1'>
      <div ref={emblaRef} className='embla__viewport'>
        <div className=' embla__container'>
          {PACKAGE_DATA.map((pack) => (
            <PackageCard key={pack.id} plan={pack} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PackageCarousel;
